import Giving from './Giving';

export default Giving;
